import { Box, Typography } from '@mui/material';
import BottomSheet from '../../../../Components/Ui/BottomSheet';

export default function WriteModeBottomSheet({ onWrite, onReuse }) {
  return (
    <BottomSheet headerText="작업허가서 작성 방법">
      <Box sx={{ px: 1, pb: 2, display: 'grid', gap: 1.5 }}>
        <Typography sx={{ color: '#7A7F7B', fontSize: 14 }}>
          새로 작성하거나 기존 허가서 내용을 불러올 수 있어요.
        </Typography>
        <button
          type="button"
          onClick={onWrite}
          className="rounded-xl bg-[#5ABD4F] px-4 py-4 text-left text-white active:opacity-80"
        >
          <strong className="block text-base">새로 작성</strong>
          <span className="mt-1 block text-xs opacity-80">
            빈 작업허가서부터 작성합니다.
          </span>
        </button>
        <button
          type="button"
          onClick={onReuse}
          className="rounded-xl border border-slate-200 bg-white px-4 py-4 text-left text-slate-800 active:bg-slate-50"
        >
          <strong className="block text-base">기존 허가서 재사용</strong>
          <span className="mt-1 block text-xs text-slate-500">
            기존 내용을 불러와 필요한 부분만 수정합니다.
          </span>
        </button>
      </Box>
    </BottomSheet>
  );
}
